<template>
	<div class="healthdetail">
		<MyVideo id="video" class="heal_video" v-on:send="send"  :src="mediaurl" :poster="mediaurl|videoposter"></MyVideo>
	</div>
</template>
<script>
    import './index.less'
    import MyVideo from '@/components/video'
    export default {
        filters: {
            videoposter(value) {
                return `${value}?x-oss-process=video/snapshot,t_5000,f_jpg,ar_auto`
            }
        },
        data(){
			return {
				id:'',
				mediaurl:'',
                only:false
			}
        },
        components:{
        	MyVideo
        },
        methods:{
            send(val){
                if(this.only) return;
                this.$api.health.videopoint({vid:this.vid,api_throw_exception:false}).then((res) => {
                    if(res.status*1==200){
                        this.only = true
                        this.$dialog.alert({
                            title: "提示",
                            message: '成功！'
                        })
                    }
                })
            }
        },
        mounted(){
            this.vid = this.$route.params.vid
            this.mediaurl = this.$route.params.mediaurl
        }
    }
</script>